
import { useState } from "react";
import { SermonFormData } from "./types";
import { useToast } from "@/hooks/use-toast";
import { useAIGeneration } from "./use-ai-generation";

export function useWelcomeDialog() {
  const { toast } = useToast();
  const { generateSermon } = useAIGeneration();
  const [showWelcomeDialog, setShowWelcomeDialog] = useState(false);
  const [showAIDialog, setShowAIDialog] = useState(false);
  const [activeTab, setActiveTab] = useState("manual");

  const handleCreateFirstSermon = (openForm: (formData?: SermonFormData) => void, formData?: SermonFormData) => {
    setShowWelcomeDialog(false);
    if (activeTab === "ai") {
      setShowAIDialog(true);
    } else {
      openForm(formData);
    }
  };

  const generateAISermon = async (createSermonPlan: (data: SermonFormData) => Promise<boolean>, fetchData: () => void) => {
    setShowAIDialog(false);
    
    toast({
      title: "Generating AI Sermon",
      description: "Creating your sermon plan...",
    });
    
    try {
      const sermonData = await generateSermon({
        title: "",
        scripture: "",
        theme: "",
      });
      
      if (sermonData) {
        // Create the sermon plan with the AI suggestion
        const success = await createSermonPlan({
          ...sermonData,
          auto_generated: true
        });
        
        if (success) {
          toast({
            title: "AI Sermon Generated",
            description: "A new sermon plan has been created based on your input.",
          });
          fetchData(); // Refresh the data
        }
      }
    } catch (error) {
      console.error("Error in generateAISermon:", error);
      toast({
        title: "Error",
        description: "Failed to generate sermon plan. Please try again.",
        variant: "destructive",
      });
    }
  };

  return {
    showWelcomeDialog,
    showAIDialog,
    activeTab,
    setShowWelcomeDialog,
    setShowAIDialog,
    setActiveTab,
    handleCreateFirstSermon,
    generateAISermon
  };
}
